export default __webpack_public_path__ + "static/media/icon-next-page.c44d93dd.svg";